<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div v-if="loading">
      <loading />
    </div>

    <div class="mt-15 ml-15 mr-15">
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_a") }} </v-card-title>
        <tablea-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportA />
          <EnReportA />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_b") }} </v-card-title>
        <tableb-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportB />
          <en-report-b />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_c") }} </v-card-title>
        <tablec-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportC />
          <en-report-c />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_d") }} </v-card-title>
        <tabled-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportD />
          <en-report-d />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_e") }} </v-card-title>
        <tablee-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportE />
          <en-report-e />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_f") }} </v-card-title>
        <tablef-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportF />
          <en-report-f />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_g") }} </v-card-title>
        <tableg-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportG />
          <en-report-g />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_h") }} </v-card-title>
        <tableh-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportH />
          <en-report-h />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_i") }} </v-card-title>
        <tablei-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportI />
          <en-report-i />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_j") }} </v-card-title>
        <tablej-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportJ />
          <en-report-j />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_k") }} </v-card-title>
        <tablek-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportK />
          <en-report-k />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_l") }} </v-card-title>
        <tablel-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportL />
          <en-report-l />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions> </v-card
      ><v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_m") }} </v-card-title>
        <tablem-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportM />
          <en-report-m />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions> </v-card
      ><v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_n") }} </v-card-title>
        <tablen-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportN />
          <en-report-n />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions> </v-card
      ><v-card class="mt-5">
        <v-card-title class="primary--text">{{ $t("fchart.mod_o") }} </v-card-title>
        <tableo-status />
        <v-card-actions>
          <v-spacer></v-spacer>
          <ReportO />
          <en-report-o />
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import TableaStatus from "@/components/Fchart/TableaStatus";
import TablebStatus from "@/components/Fchart/TablebStatus";
import TablecStatus from "@/components/Fchart/TablecStatus";
import TabledStatus from "@/components/Fchart/TabledStatus";
import TableeStatus from "@/components/Fchart/TableeStatus";
import TablefStatus from "@/components/Fchart/TablefStatus";
import TablegStatus from "@/components/Fchart/TablegStatus";
import TablehStatus from "@/components/Fchart/TablehStatus";
import TableiStatus from "@/components/Fchart/TableiStatus";
import TablejStatus from "@/components/Fchart/TablejStatus";
import TablekStatus from "@/components/Fchart/TablekStatus";
import TablelStatus from "@/components/Fchart/TablelStatus";
import TablemStatus from "@/components/Fchart/TablemStatus";
import TablenStatus from "@/components/Fchart/TablenStatus";
import TableoStatus from "@/components/Fchart/TableoStatus";
import ReportA from "@/components/Fchart/Reports/NL/ReportA";
import ReportB from "@/components/Fchart/Reports/NL/ReportB";
import ReportC from "@/components/Fchart/Reports/NL/ReportC";
import ReportD from "@/components/Fchart/Reports/NL/ReportD";
import ReportE from "@/components/Fchart/Reports/NL/ReportE";
import ReportF from "@/components/Fchart/Reports/NL/ReportF";
import ReportG from "@/components/Fchart/Reports/NL/ReportG";
import ReportH from "@/components/Fchart/Reports/NL/ReportH";
import ReportI from "@/components/Fchart/Reports/NL/ReportI";
import ReportJ from "@/components/Fchart/Reports/NL/ReportJ";
import ReportK from "@/components/Fchart/Reports/NL/ReportK";
import ReportL from "@/components/Fchart/Reports/NL/ReportL";
import ReportM from "@/components/Fchart/Reports/NL/ReportM";
import ReportN from "@/components/Fchart/Reports/NL/ReportN";
import ReportO from "@/components/Fchart/Reports/NL/ReportO";
import FchartService from "@/services/fchart/FchartService";
import Loading from "@/components/loading";
import EnReportA from "@/components/Fchart/Reports/En/EnReportA";
import EnReportB from "@/components/Fchart/Reports/En/EnReportB";
import EnReportC from "@/components/Fchart/Reports/En/EnReportC";
import EnReportD from "@/components/Fchart/Reports/En/EnReportD";
import EnReportE from "@/components/Fchart/Reports/En/EnReportE";
import EnReportF from "@/components/Fchart/Reports/En/EnReportF";
import EnReportG from "@/components/Fchart/Reports/En/EnReportG";
import EnReportH from "@/components/Fchart/Reports/En/EnReportH";
import EnReportI from "@/components/Fchart/Reports/En/EnReportI";
import EnReportJ from "@/components/Fchart/Reports/En/EnReportJ";
import EnReportK from "@/components/Fchart/Reports/En/EnReportK";
import EnReportL from "@/components/Fchart/Reports/En/EnReportL";
import EnReportM from "@/components/Fchart/Reports/En/EnReportM";
import EnReportN from "@/components/Fchart/Reports/En/EnReportN";
import EnReportO from "@/components/Fchart/Reports/En/EnReportO";

export default {
  name: "fchartview",
  components: {
    EnReportO,
    EnReportN,
    EnReportM,
    EnReportL,
    EnReportK,
    EnReportJ,
    EnReportI,
    EnReportH,
    EnReportG,
    EnReportF,
    EnReportE,
    EnReportD,
    EnReportC,
    EnReportB,
    EnReportA,
    Loading,
    ToolbarAuth,
    Navigation,
    TableaStatus,
    TablebStatus,
    TablecStatus,
    TabledStatus,
    TableeStatus,
    TablefStatus,
    TablegStatus,
    TablehStatus,
    TableiStatus,
    TablejStatus,
    TablekStatus,
    TablelStatus,
    TablemStatus,
    TablenStatus,
    TableoStatus,
    ReportA,
    ReportB,
    ReportC,
    ReportD,
    ReportE,
    ReportF,
    ReportG,
    ReportH,
    ReportI,
    ReportJ,
    ReportK,
    ReportL,
    ReportM,
    ReportN,
    ReportO,
  },
  data() {
    return {
      loading: false,
      dataext: {},
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.famId;
      this.loading = true;
      FchartService.getMain(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    closeView() {
      this.$router.replace({
        name: "fchartIndex",
      });
    },
  },
  computed: {
    // ...mapGetters("fchartresult", ["astoremodules"]),
    // ...mapGetters("fchartBresult", ["bstoremodules"]),
    ...mapGetters("colors", ["colors"]),
  },

  created() {
    let id = this.$route.params.famId;
    this.$store.dispatch("fchartresult/getAmodule", id);
    this.$store.dispatch("fchartBresult/getAmodule", id);
    this.$store.dispatch("fchartCresult/getAmodule", id);
    this.$store.dispatch("fchartDresult/getAmodule", id);
    this.$store.dispatch("fchartEresult/getAmodule", id);
    this.$store.dispatch("fchartFresult/getAmodule", id);
    this.$store.dispatch("fchartGresult/getAmodule", id);
    this.$store.dispatch("fchartHresult/getAmodule", id);
    this.$store.dispatch("fchartIresult/getAmodule", id);
    this.$store.dispatch("fchartJresult/getAmodule", id);
    this.$store.dispatch("fchartKresult/getAmodule", id);
    this.$store.dispatch("fchartLresult/getAmodule", id);
    this.$store.dispatch("fchartMresult/getAmodule", id);
    this.$store.dispatch("fchartNresult/getAmodule", id);
    this.$store.dispatch("fchartOresult/getAmodule", id);
    this.$store.dispatch("fchartresult/getAmodule", id);

    let colorId = 1;
    this.$store.dispatch("colors/getMains", colorId);
    this.getData();
  },
};
</script>

<style scoped></style>
